// src/kdramas.js

export const kdramas = [
  {
    title: "When Life Gives You Tangerines",
    description: "When Netflix released the trailer for this series, I was intrigued, h the tender portrayal of a mother's love, transitioning through the complexities of romance, and ultimately returning to the profound bond between mother and child, this series captures the essence of human connection. The storytelling is filled with heartwarming moments that will not only bring genuine joy but also move you to tears with its emotional depth. The compelling male lead's performance is particularly captivating, making this a must-watch experience you shouldn't delay another moment",
       imageUrl:
      "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/When+Life+Gives+You+Tangerines%2C+%E1%84%91%E1%85%A9%E1%86%A8%E1%84%8A%E1%85%A1%E1%86%A8%E1%84%89%E1%85%A9%E1%86%A8%E1%84%8B%E1%85%A1%E1%86%BB%E1%84%89%E1%85%AE%E1%84%83%E1%85%A1+(2025).jpeg",
    rating: 5,
    whereToWatch:"https://upload.wikimedia.org/wikipedia/commons/0/08/Netflix_2015_logo.svg",
    alt: "Netflix",
    href: "https://www.netflix.com/gb/title/81681535?source=35"
  },
  {
    title: "Reply 1988",
    description:"Imagine you just come inside your house on a cold, chilly day and when you enter the house, you feel the warmth. This series is like this. It has so many characters and each character has its own impact, a nostalgia of the '90s. The series has love story, friendship story, and a chemistry of neighbors. Trust me, once you start to watch the series, there is no way back, and I have watched it so many times, but every time I watch, I fall in love with this series again and again. And yes, please don't skip the intro for atleast one episode.",
        imageUrl:
      "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Reply1988.jpeg",
    rating: 5,
    whereToWatch:"https://upload.wikimedia.org/wikipedia/commons/0/08/Netflix_2015_logo.svg",
    alt: "Netflix",
    href: "https://www.netflix.com/in/title/80188351?source=35"
  },
  {
    title: "Crash Landing on You",
    description:
      "A South Korean heiress crashes into North Korea and meets a soldier.",
    imageUrl:
      "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/CrashLandingonYouK-dramaOfficialposterNetflix.jpeg",
    rating: 4,
  },
  {
    title: "Lovely runner",
    description: "The chemistry between the lead actors is exceptional, creating heartfelt moments that will resonate with viewers long after watching. Byeon Woo-seok delivers a nuanced performance as Sun-jae, portraying both vulnerability and strength, while Kim Hye-yoon brings authenticity and determination to Im Sol's character.What sets this drama apart is its thoughtful exploration of destiny, second chances, and the butterfly effect of our actions. The time travel element is handled with care, creating compelling narrative stakes rather than serving as a mere plot device",
          imageUrl:
      "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/lovelyrunner.jpeg",
    rating: 3.5,
    href: "https://www.netflix.com/in/title/81914565?source=35",
    whereToWatch:"https://upload.wikimedia.org/wikipedia/commons/0/08/Netflix_2015_logo.svg",
    alt: "Netflix"
  },
  {
    title: "Guardian the lonely and great god",
    description:
      "A story about overcoming struggles and achieving dreams in the tough streets of Itaewon.",
    imageUrl:
      "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/goblin.jpeg",
    rating: 4,
     whereToWatch:"https://upload.wikimedia.org/wikipedia/commons/0/08/Netflix_2015_logo.svg",
    alt: "Netflix"
  },

  {
    title: "True beauty",
    description:
      "A story about overcoming struggles and achieving dreams in the tough streets of Itaewon.",
    imageUrl:
      "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Truebeauty.jpeg",
    rating: 5,
  },
  {
    title: "Strong woman Do bong Soon",
    description:
      "A story about overcoming struggles and achieving dreams in the tough streets of Itaewon.",
    imageUrl:
      "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Strong+woman+Do+bong+Soon.jpeg",
    rating: 5,
  },
  {
    title: "The legend of the blue sea",
    description:
      "A story about overcoming struggles and achieving dreams in the tough streets of Itaewon.",
    imageUrl:
      "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/legend.jpeg",
    rating: 5,
  },
  {
    title: "Study group",
    description:
      "A story about overcoming struggles and achieving dreams in the tough streets of Itaewon.",
    imageUrl:
      "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/StudyGroup.jpeg",
    rating: 5,
  },
  {
    title: "Alchemy of souls",
    description:
      "A story about overcoming struggles and achieving dreams in the tough streets of Itaewon.",
    imageUrl:
      "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/AlchemyOfSouls.jpeg",
    rating: 5,
  },
  {
    title: "Business proposal",
    description:
      "A story about overcoming struggles and achieving dreams in the tough streets of Itaewon.",
    imageUrl:
      "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/U%CC%88zleti+Aja%CC%81nlat.jpeg",
    rating: 5,
  },
  {
    title: "When the phone rings",
    description:
      "A story about overcoming struggles and achieving dreams in the tough streets of Itaewon.",
    imageUrl:
      "https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/Yoo+yeon+seok+y+Chae+Soo-bin+cuando+el+tele%CC%81fono+suena.jpeg",
    rating: 5,
  },
];
